import React from "react";

//component

import WhatsNewBanner from "views/whats-new/components/WhatsNewBanner.js";
import Gallery from "views/whats-new/components/Gallery.js";
import FooterSection from "views/home/components/FooterSection";

class WhatsNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="mt-80px  lg:pt-8 md:pt-8">
        <div className="mx-auto container ">
          <WhatsNewBanner />
        </div>
        <div className=" lg:px-0 md:px-0 px-5">
          {" "}
          <div className="mx-auto container ">
            <Gallery />
          </div>
        </div>

        <div className="mt-6 footer-css">
          <FooterSection />
        </div>
      </div>
    );
  }
}

export default WhatsNew;
